/** Operator-facing errors for pattern group actions (dry-run, execute, background). */
export function humanizePatternGroupActionError(detail: string): string {
  const raw = String(detail || '').trim();
  const lower = raw.toLowerCase();

  if (
    lower.includes('timeout')
    || lower.includes('504')
    || lower.includes('gateway time')
    || lower.includes('deadline')
    || lower.includes('exceeded')
  ) {
    return (
      'The server took too long to finish this recurring-risk action (often 2,000+ open linked records). '
      + 'Try again after deploy, narrow the review window, or contact ops if it keeps failing.'
    );
  }

  if (lower.includes('502') || lower.includes('bad gateway') || lower.includes('db_unreachable')) {
    return (
      'The API was temporarily unavailable (gateway error). Wait a moment and try Refresh count, then Apply again.'
    );
  }

  if (
    lower.includes('max_members_exceeded')
    || lower.includes('exceeds max_members')
    || (lower.includes('matched_count') && lower.includes('max_members'))
  ) {
    return (
      'Too many open observations match this action in one step. '
      + 'Narrow the review window and try again, or contact support if this keeps happening.'
    );
  }

  return raw || 'Recurring-risk action failed.';
}
